import useGetApi from "./useGetApi"
import useMutateApi from "./useMutateApi"
// constants
import apiEndpoints from "api/utils/apiEndpoints"
import queryKeys from "api/utils/queryKeys"
import getUrl from "api/apiMap"

// other apis
import { useGetFavoriteStudies } from "api/hooks/studies/useStudiesApi"
import { useGetFavoriteRequests } from "api/hooks/requests/requestFavoritesApis"

// user-info
const useUserInfo = () => {
  return useGetApi(getUrl(apiEndpoints.userInfo), queryKeys.userInfo)
}

// user-permissions
const useUserPermissions = () => {
  return useGetApi(getUrl(apiEndpoints.userPermissions), queryKeys.userPermissions)
}

// user-settings
const useUserSettings = () => {
  return useGetApi(getUrl(apiEndpoints.userSettings), queryKeys.userSettings)
}

const usePostUserSettings = () => {
  return useMutateApi({
    method: "post",
    apiEndpoint: getUrl(`${apiEndpoints.userSettings}`),
    invalidateQueries: [queryKeys.userSettings],
    successMsg: "Successfully updated settings",
  })
}

const usePollTask = (taskId, options) => {
  return useGetApi(taskId ? getUrl(apiEndpoints.pollTask + taskId) : null, queryKeys.pollingTask(taskId), options)
}

const useGetPasswordExpiryDeadline = () => {
  return useGetApi(getUrl(apiEndpoints.pwdExpiryDeadline), [])
}

export {
  useGetApi,
  useMutateApi,

  // user-info
  useUserInfo,

  // user-permissions
  useUserPermissions,

  // user-settings
  useUserSettings,
  usePostUserSettings,
  usePollTask,
  useGetPasswordExpiryDeadline,

  // imported apis
  useGetFavoriteStudies,
  useGetFavoriteRequests,
}
